import { Box, Button, Chip, Stack, Typography, useTheme } from '@mui/material'
import { ReactNode } from 'react'
import { IconButton, TextLink } from 'utoniq-ui'

import { BaseLayout } from '@/components/layouts'
import { FullscreenModal } from '@/components/organisms/functionals'
import { config } from '@/config'
import { useTranslation } from '@/core'
import { marketOpen } from '@/core/native/app'

type MetamaskWalletConnectInfoModalProps = {
  open: boolean
  onClose: () => void
}
/**
 * @description
 * モバイルアプリ用のメタマスクアプリとUtoniqアプリ連携の使い方説明用モーダル
 */
export const MetamaskWalletConnectInfoModal = ({
  open,
  onClose,
}: MetamaskWalletConnectInfoModalProps) => {
  const { t } = useTranslation('metamaskWalletConnectInfoModal')
  const { zIndex } = useTheme()

  return (
    <FullscreenModal
      open={open}
      onClose={onClose}
      sx={{ zIndex: zIndex.modal + 3 }}
    >
      <BaseLayout
        margin
        header={{
          title: t('title'),
          left: <IconButton.Close onClick={onClose} sx={{ ml: -2 }} />,
        }}
      >
        <Typography variant="body2" sx={{ py: 2 }}>
          {t('howTo')}
        </Typography>

        <Stack gap={3}>
          <StepContent
            stepNumber={1}
            title={t('step1.title')}
            content={
              <>
                <Typography variant="caption" sx={{ pb: 2 }}>
                  {t('step1.content1')}
                </Typography>

                <TextLink
                  variant="caption"
                  onClick={() =>
                    marketOpen({
                      iosAppId: '1438144202',
                      androidAppId: 'io.metamask',
                    })
                  }
                >
                  {t('step1.content2')}
                </TextLink>
              </>
            }
          />

          <StepContent
            stepNumber={2}
            title={t('step2.title')}
            content={
              <>
                <Typography variant="caption" sx={{ pb: 2 }}>
                  {t('step2.content1')}
                </Typography>

                <Typography variant="caption" color="error" sx={{ pb: 2 }}>
                  {t('step2.content2')}
                </Typography>

                <Box alignSelf="center">
                  <Button
                    sx={{ mt: 3 }}
                    fullWidth={false}
                    onClick={() =>
                      window.open(
                        `https://metamask.app.link/dapp/${config.domain}/login?redirectUri=${location.pathname}`
                      )
                    }
                  >
                    {t('step2.content3')}
                  </Button>
                </Box>
              </>
            }
          />
        </Stack>
      </BaseLayout>
    </FullscreenModal>
  )
}

type StepContentProps = {
  stepNumber: number
  title: string
  content: ReactNode
}
const StepContent = ({ stepNumber, title, content }: StepContentProps) => {
  return (
    <Stack sx={{ p: 3, bgcolor: 'grey.50', borderRadius: 3 }}>
      <Chip label={`STEP ${stepNumber}`} style={{ borderRadius: 60 }} />

      <Typography variant="subtitle1" sx={{ py: 2 }}>
        {title}
      </Typography>

      {content}
    </Stack>
  )
}
